import "./src/scss/index.scss"
